import Seo from "@/components/Seo";
import React from "react";
import Hero from "@/components/Hero";
import ProblemSection from "@/components/sections/ProblemSection";
import TwoSidesSection from "@/components/sections/TwoSidesSection";
import HowItWorksSection from "@/components/sections/HowItWorksSection";
import DataSection from "@/components/sections/DataSection";
import FeaturesSection from "@/components/sections/FeaturesSection";
import BeforeAfterSection from "@/components/sections/BeforeAfterSection";
import UseCasesSection from "@/components/sections/UseCasesSection";
import PricingSection from "@/components/sections/PricingSection";
import ProofSection from "@/components/sections/ProofSection";
import TrustSection from "@/components/sections/TrustSection";
import FAQSection from "@/components/sections/FAQSection";
import FinalCTASection from "@/components/sections/FinalCTASection";
import AppShowcase from "@/components/AppShowcase";

export default function HomePage() {
  return (
    <main>
      <Seo
        path="/"
        jsonLd={[
          { "@context": "https://schema.org", "@type": "Organization", name: "WorkPay", legalName: "Furroo FZE LLC", url: "https://workpay-app.com/", logo: "https://customer-assets.emergentagent.com/job_milestone-first/artifacts/iwvmscu3_Workpay-2.svg", email: "support@workpay-app.com", telephone: "+971552239345", description: "WorkPay is software for managing project-payment workflows for UAE service businesses — projects, milestones, customer approvals and payouts, processed through Stripe.", founder: { "@type": "Person", name: "Roshan Hegde", jobTitle: "Founder", sameAs: "https://www.linkedin.com/in/roshan-hegde-8b277311b/" }, address: { "@type": "PostalAddress", addressLocality: "Dubai", addressCountry: "AE" }, sameAs: ["https://www.linkedin.com/in/roshan-hegde-8b277311b/"] },
          { "@context": "https://schema.org", "@type": "SoftwareApplication", name: "WorkPay", applicationCategory: "FinanceApplication", operatingSystem: "Web", url: "https://workpay-app.com/", description: "Stripe-powered project payment workflow for service vendors and customers: milestones, approvals and protected payouts.", offers: { "@type": "Offer", priceCurrency: "AED", description: "Domestic-card payments 2.9% + AED 1 (Simple Payment Link) or 3.95% + AED 1 (Milestone Payments), processed through Stripe." } },
        ]}
      />
      <Hero />
      <ProblemSection />
      <TwoSidesSection />
      <HowItWorksSection />
      <DataSection />
      <FeaturesSection />
      <AppShowcase />
      <BeforeAfterSection />
      <UseCasesSection />
      <PricingSection />
      <ProofSection />
      <TrustSection />
      <FAQSection />
      <FinalCTASection />
    </main>
  );
}
